import React from "react";
import { NAV_LINKS } from "../constants/nav-links.constant";

export default function Footer() {
  return (
    <footer className="bg-[#0042c3] p-4 mt-10">
      <div className="flex justify-center">
        <span className="text-white">
          v{process.env.REACT_APP_VERSION}
        </span>
      </div>
    </footer>
  );
}
